import { toast, Id } from "react-toastify";

const errorToastIds = new Set<Id>();
const MAX_ERROR_TOASTS = 2;

const originalError = toast.error;

toast.error = ((content, options) => {
  if (errorToastIds.size >= MAX_ERROR_TOASTS) {
    toast.dismiss();
    errorToastIds.clear();
  }

  let toastId: Id;
  toastId = originalError(content, {
    ...options,
    onClose: (props) => {
      errorToastIds.delete(toastId);
      options?.onClose?.(props);
    },
  });

  errorToastIds.add(toastId);
  return toastId;
}) as typeof toast.error;
